export default __webpack_public_path__ + "static/summer_containers17-9a3ae04f4f99affbee88caeda6dea51e.webp";